
    var swiper = new Swiper(".favourite-stadiums .swiper", {
      slidesPerView: 1,
      grabCursor: true,
      spaceBetween: 45,
      navigation: {
        nextEl: ".swiper-next",
        prevEl: ".swiper-prev",
      },
    });

    var swiper = new Swiper(".testimonials .swiper", {
      slidesPerView: 1,
      grabCursor: true,
      spaceBetween: 20,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      breakpoints: {
        992: {
          slidesPerView: 2,
          spaceBetween: 45,
        },
      },
    });

    var swiper = new Swiper(".site-gallery .swiper", {
      centeredSlides: true,
      spaceBetween: 20,
      speed: 6000,
      autoplay: {
        delay: 1,
      },
      loop: true,
      slidesPerView: "auto",
      allowTouchMove: false,
      disableOnInteraction: true,
      breakpoints: {
        992: {
          spaceBetween: 32,
        },
      },
    });
